import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatCurrency } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { ItemDisplay } from './itemDisplay';
import { PointsAndFeesDetailsAccordion } from './pointsAndFeesDetailsAccordion';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

const useStyles = makeStyles(theme => ({
  paper: {
    border: `1px solid lightgray`,
    borderRadius: '16px !important',
    padding: theme.spacing(4),
  },
}));

interface EconomicsSummaryCardProps {
  store: IQuoteTypeStore;
  showPointsAndFees?: boolean;
}

export const EconomicsSummaryCard = observer(
  ({ store, showPointsAndFees }: EconomicsSummaryCardProps) => {
    const classes = useStyles();
    const calculatedFields = store.loanEconomicsStore.calculateFields();

    return (
      <Paper className={classes.paper} elevation={0}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{ marginLeft: '1rem', marginRight: '24px' }}
          >
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <ItemDisplay
                  label="Lender Fees"
                  value={formatCurrency(calculatedFields.totalLenderFees)}
                />
              </Grid>
              <Grid item>
                <ItemDisplay
                  label="Estimated Third Party Fees"
                  value={formatCurrency(calculatedFields.thirdPartyCosts)}
                  tooltip="These are estimates based on historical data of similar loans."
                />
              </Grid>
              <Grid item>
                <ItemDisplay
                  label="Interest Reserve"
                  value={formatCurrency(calculatedFields?.interestReserve)}
                />
              </Grid>
            </Grid>
          </Grid>
          {!!showPointsAndFees && (
            <Grid item xs={12}>
              <PointsAndFeesDetailsAccordion store={store} />
            </Grid>
          )}
        </Grid>
      </Paper>
    );
  }
);
